"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingParametersInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const VestingParametersInput = (props) => {
    const { prefix = "parameters" } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { sx: { p: 2, display: "flex", alignItems: "stretch", flex: 1, flexDirection: "column" }, children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: `${prefix}.owner` }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateInput, { name: `${prefix}.startTimestamp` }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: `${prefix}.cliffInMonth` }), (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { name: `${prefix}.monthlyRelease`, symbol: "%" })] }));
};
exports.VestingParametersInput = VestingParametersInput;
//# sourceMappingURL=index.js.map